<template>
    <div id="home_wrapper">
        <section id="home" style="overflow-x: hidden!important">
            <b-container class="header position-relative">
                <img src="/img/1063-header-large.svg" alt="" class="w-100 d-md-none d-block">
                <div class="header-large-1063">
                    <img src="/img/1063-header-large.svg" alt="" class="img-1063 d-md-block d-none">
                    <div class="header-text gotham-book fade-in-up-element">
                        #1063. A place where ordinary isn't welcome. Where normal is kicked to the curb. Where art isn't reserved for museums. Where Artists, Writers, and Thinkers do lead. And where Toronto's foremost creative agency calls home.
                    </div>
                    <div class="header-bottom-left-quotes">
                        <nuxt-img 
                            loading="lazy" 
                            provider="static" 
                            format="webp"
                            src="/img/quotes-left.png" 
                            alt="Quotations"
                            class="d-block max-w-40"
                            width="40"
                            height="31"
                            sizes="lg:41px"
                        />
                        <p class="h4 mt-4 fade-in-up-element gotham-book" style="line-height: 150%">
                            We do it all and we do it
                            <br>
                            well. Our departments
                            <br>
                            work in tandem to ...
                        </p>
                        <div class="d-flex justify-content-between">
                            <nuxt-img 
                                loading="lazy" 
                                provider="static" 
                                format="webp"
                                src="/img/quotes-right.png" 
                                alt="Quotations"
                                class="d-block max-w-40 w-100 h-100 ml-auto"
                                width="40"
                                height="31"
                                sizes="lg:41px"
                            />
                        </div>
                    </div>
                </div>
                
                <div class="header-social fade-in-up-element">
                    <div class="icons">
                        <a href="https://www.facebook.com/guidelinesad/" target="_blank">
                        <nuxt-img loading="lazy" provider="static" format="webp"
                            src="/img/ga-fb-pink.png"
                            alt="Facebook"
                            class="w-100 social-icon"
                            width="30"
                            height="30"
                            sizes="lg:30px"
                        />
                        </a>
                        <a href="https://www.tiktok.com/@guidelines1063" target="_blank">
                        <nuxt-img loading="lazy" provider="static" format="webp"
                            src="/img/ga-tt-pink.png"
                            alt="Tik Tok"
                            class="w-100 social-icon"
                            width="30"
                            height="30"
                            sizes="lg:30px"
                        />
                        </a>
                        <a href="https://www.instagram.com/1063_guidelines/" target="_blank">
                        <nuxt-img loading="lazy" provider="static" format="webp"
                            src="/img/ga-ig-pink.png"
                            alt="Instagram"
                            class="w-100 social-icon"
                            width="30"
                            height="30"
                            sizes="lg:30px"
                        />
                        </a>
                        <a href="https://www.linkedin.com/company/guidelines-advertising-ltd/mycompany/?viewAsMember=true" target="_blank">
                        <nuxt-img loading="lazy" provider="static" format="webp"
                            src="/img/ga-li-pink.png"
                            alt="Linked In"
                            class="w-100 social-icon"
                            width="30"
                            height="30"
                            sizes="lg:30px"
                        />
                        </a>
                        
                    </div>
                </div>
            </b-container>
            <!--  -->
            <TickerTextMultipleLines class="mt-100 pb-120"/>
            <!--  -->
            <div class="bg-black py-5 conclusion">
                <b-container class="text-white">
                    <p class="gotham-book">ONE STOP SHOP</p>
                    <p class="reveal-text h3 mt-5 gotham-book">
                        <span class="ga-pink gotham-book">It all happens at 1063.</span>
                        It's where the visions of greatness are brought to life through brains, talent, and teamwork. Sure, we'll tell you more -- but after creating award-winning work for nearly four decades, we've found that success speaks for itself.
                        <br>
                        <br>
                        So go ahead. Take a look.
                    </p>
                    
                </b-container>
            </div>
            <div class="home-video">
                <video src="/videos/home-portfolio.mp4" class="w-100 d-block" 
                autoplay loop playsinline muted></video>
                <nuxt-link to="/portfolio" class="hover-overlay">
                    <div class="portfolio-text">
                        <img src="/img/portfolio-text.svg" alt="Portfolio" class="w-100">
                    </div>
                </nuxt-link>
            </div>
            <!-- <Transition1063 /> -->
            <AppFooter />
        </section>
    </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

export default {
    
    data() {
        return {
            scrollSmoother_home: null,
            textAnimation_home: null,
            fadeInUpElement_home: null,
        }
    },
    components: {
        LoadingComponent: () => import('@/components/LoadingComponent'),
        TickerTextSingleLine: () => import('@/components/TickerTextSingleLine'),
        TickerTextMultipleLines: () => import('@/components/TickerTextMultipleLines'),
        Transition1063: () => import('@/components/Transition1063'),
        AppFooter: () => import('@/components/AppFooter'),
    },
    mounted() {
        gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText);
        ScrollTrigger.refresh();
        
        setTimeout(() => {
            this.initScrollSmoother_homePage();
            // 
            this.initImgElReveal_homePage();
            this.initTextReveal_homePage();
        }, 500)
    },
    methods: {
        initScrollSmoother_homePage() {
            this.scrollSmoother_home = ScrollSmoother.create({
                wrapper: '#home_wrapper',
                content: "#home",
                smooth: 5,
                effects: true
            });
            this.scrollSmoother_home.effects(".plax-img", { speed: "auto" });
        },
        initImgElReveal_homePage() {
            let fadeInUpEl = document.querySelectorAll(".fade-in-up-element");

            fadeInUpEl.forEach((container) => {
                let fadeInUpElement_home = this.fadeInUpElement_home;
                fadeInUpElement_home = gsap.timeline({
                    scrollTrigger: {
                        trigger: container,
                        start: "center bottom",
                        stagger: 0.2
                    }
                });

                fadeInUpElement_home.set(container, { autoAlpha: 1 });
                fadeInUpElement_home.from(container, 1, {
                    opacity: 0,
                    y: 100,
                    ease: "power2.out"
                });
            });
        },
        initTextReveal_homePage() {
            let revealText = document.querySelectorAll(".reveal-text");
            revealText.forEach((container) => {
                let textAnimation_home = this.textAnimation_home;
                textAnimation_home = gsap.timeline({
                    scrollTrigger: {
                        trigger: container,
                        start: "center bottom",
                        stagger: 0.1
                    }
                });

                var splitHide = new SplitText(container, { type: "words", wordsClass: "hide-text" });
                var split = new SplitText(container, {
                    type: "words",
                    wordsClass: "words",
                });
                textAnimation_home.set(container, { autoAlpha: 1 });
                textAnimation_home.from(split.words, {
                    delay: 0.5,
                    duration: 0.35,
                    yPercent: 100,
                    stagger: 0.03,
                    ease: 'power2.out'
                });
            })
        }
    },
    beforeDestroy() {
        setTimeout(() => {
            this.scrollSmoother_home.kill();
            console.log('ScrollTrigger killed in ' + this.$route.name)
        }, 500)
    }
}
</script>

<style scoped lang="scss">
#home {
    background-image: url('/img/stipple-background.jpg');
    background-position: center;
    background-size: cover;
    width: 100%;
    z-index: 2;
    padding-top: 160px;

    .header {
        // top: 160px;
        
        .header-text {
            position: absolute;
            right: 0;
            top: 0;
            max-width: 440px;

            @media screen and (max-width: 991px) {
                position: relative;
                margin-top: 40px;
            }
        }

        .header-large-1063 {
            max-width: 1000px;
            // margin: 0 auto 200px;
            // top: 200px;

            .img-1063 {
                width: 100%;

                @media screen and (max-width: 991px) {
                    width: 90%;
                    margin: 0 auto;
                }
            }

            .header-bottom-left-quotes {
                position: absolute;
                bottom: 0;
                left: 100px;

                @media screen and (max-width: 991px) {
                    position: relative;
                    left: unset;
                    max-width: 360px;
                    margin: 40px 0 0 auto;
                }
            }   
        }

        .header-social {
            display: flex;
            align-items: center;
            transform: rotate(-90deg) translate(0, -100%);
            position: absolute;
            top: 49.5%;
            left: -75px;

            @media screen and (max-width: 991px) {
                top: 30%;
            }

            @media screen and (max-width: 767px) {
                display: none;
            }
        }

        .share {
            display: flex;
            align-items: center;

            .social-line {
                width: 100px;
                height: 2px;
                background: #ff56b1;
            }
        }

        .icons {
            padding: 20px;
            .social-icon {
                max-width: 30px;
                transform: rotate(-270deg);
            }
        }
    }

    .video-text-overlay {
        position: absolute;
        top: 30px;
        right: 30px;
    }

    .ga-circular-stamp {
        position: absolute;
        right: -100px;
        bottom: -100px;
        width: 100%;
        max-width: 280px;
        z-index: 1;
    }

    .home-video {
        position: relative;
        transition: 0.25s ease-in-out;

        .hover-overlay {
            background: rgba($color: #ff56b1, $alpha: 0.7);
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            // height: 0%;
            width: 100%;
            transition: .25s ease-in-out;
            transform: scaleY(0);
            transform-origin: bottom center;

            .portfolio-text {
                position: absolute;
                bottom: 12rem;
                right: 9rem;
                width: 38vw;
                @media screen and (max-width: 767px) {
                    bottom: 15px;
                    right: 15px;
                }
            }
        }

        &:hover {
            .hover-overlay {
                transform: scaleY(1)
            }
        }
    }
}
</style>